var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVsdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.56 2.85 13.15.44A1.52 1.52 0 0 0 12.09 0H5.5A1.5 1.5 0 0 0 4 1.5v13A1.5 1.5 0 0 0 5.5 16h9a1.5 1.5 0 0 0 1.5-1.5V3.91a1.52 1.52 0 0 0-.44-1.06zm-.71.71a.49.49 0 0 1 .15.35V4h-1.5a.5.5 0 0 1-.5-.5V1.71l1.85 1.85zM5.5 15h9a.5.5 0 0 0 .5-.5V5h-1.5A1.5 1.5 0 0 1 12 3.5V1H5.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5z",
    fill: "#605E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15h9a.5.5 0 0 0 .5-.5V5h-1.5A1.5 1.5 0 0 1 12 3.5V1H5.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4v-.09a.49.49 0 0 0-.15-.35L13 1.71V3.5a.5.5 0 0 0 .5.5H15z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 9,
    height: 9,
    rx: 1,
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23 11 2.02 6h.95l1.54 3.56L6.02 6H7l-2.22 5h-.55z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11h-1v-1h1a.5.5 0 0 0 .5-.5v-3h1v3a1.5 1.5 0 0 1-1.5 1.5z",
    fill: "#185ABD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "m10.996 6.497 1.499-1.499 1.5 1.5-1.5 1.498z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M10 9h1v3h-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsdx);
export default __webpack_public_path__ + "static/media/vsdx.8efca42c3ab974ccbb561321e3c3e687.svg";
export { ForwardRef as ReactComponent };